export const PublicAllRoute = ({ element }) => {
    return element;
};